import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { Api } from "services";

// Course duration -> moment unit ("Day(s)" / "Month(s)" / "Year(s)", or the
// 1 / 30 / 360 codes used by the course form).
const durationUnitOf = (durationType) => {
    const type = String(durationType ?? "").trim().toLowerCase();
    if (type.startsWith("day") || type === "1") return "days";
    if (type.startsWith("month") || type === "30") return "months";
    if (type.startsWith("year") || type === "360") return "years";
    return null;
};

// Loads the course's duration (GET /course?id=) while `visible`, and returns
// getAutoEndDate(startDate) -> start + duration - 1 day (same as the course
// form), or null when the duration isn't known.
const useCourseEndDate = (visible, courseId) => {
    const [courseDuration, setCourseDuration] = useState(null);

    useEffect(() => {
        setCourseDuration(null);
        if (!visible || !courseId || courseId === -1 || courseId === "-1") return undefined;
        let cancelled = false;
        Api.get("/course").params({ id: courseId }).send((response) => {
            if (cancelled || !response || response?.show?.type === "error") return;
            const course = response?.course || response;
            const duration = parseInt(course?.duration, 10);
            const unit = durationUnitOf(course?.durationType);
            if (duration > 0 && unit) setCourseDuration({ duration, unit });
        }, true);
        return () => { cancelled = true; };
    }, [visible, courseId]);

    return useCallback((startDate) => {
        if (!startDate || !courseDuration) return null;
        const end = moment(startDate).clone().add(courseDuration.duration, courseDuration.unit).subtract(1, "days");
        return end.isValid() ? end : null;
    }, [courseDuration]);
};

export default useCourseEndDate;
